import { FC, ReactNode, useEffect } from 'react';
import { steps } from './SequenceSteps';
import useOnboardingProjectStore from 'stores/onboardingProjectStore';
import ProgressBar from './ProgressBar';
import { ProjectV1BaseServerRepo } from 'core/repository/base-server/v1/project.repo';

const OnboardingProjectSequence = () => {
  const {
    progressStep,
    setPercentCompleted,
    rotateVault,
    setProjectInfo,
    setUserProject,
  } = useOnboardingProjectStore();

  useEffect(() => {
    setPercentCompleted(steps[progressStep].progressOnMount);
    rotateVault(50);
  }, [progressStep]);

  useEffect(() => {
    fetchProject();
  }, []);

  const fetchProject = async () => {
    const appProjects = await new ProjectV1BaseServerRepo().getProjects();
    if (appProjects.data.length) {
      // console.log('project----',appProjects.data[0])
      setUserProject(appProjects.data[0]);
      setProjectInfo('name', appProjects.data[0].name);
      setProjectInfo('description', appProjects.data[0].description);
      setProjectInfo('xUsername', appProjects.data[0].xUsername);
      if (appProjects.data[0]?.projectVideoUrl)
        setProjectInfo('projectVideoUrl', appProjects.data[0].projectVideoUrl);
      if (appProjects.data[0]?.whitePaper)
        setProjectInfo('whitePaper', appProjects.data[0].whitePaper);
      if (appProjects.data[0]?.website)
        setProjectInfo('website', appProjects.data[0].website);
      if (appProjects.data[0]?.discordGuildId)
        setProjectInfo('discordGuildId', appProjects.data[0].discordGuildId);
      if (appProjects.data[0]?.telegramUsername)
        setProjectInfo(
          'telegramUsername',
          appProjects.data[0].telegramUsername
        );
    }
  };

  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-[30px] py-[30px]">
      {steps[progressStep].component}
      {/* <div> */}
      <ProgressBar />
      {/* </div> */}
    </div>
  );
};

export const SequenceItem: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="flex flex-col items-center w-full h-fit gap-[30px]">
    {children}
  </div>
);

export default OnboardingProjectSequence;
